import Vue from 'vue'
import VueRouter from 'vue-router'
// import routes from './router'
import App from './App.vue'
import store from '@/store'
import { GET_USER } from '@/store/types'
const types = require('@/store/types')
const Tip = require('@/lib/tip').default
const wx = require('weixin-js-sdk');
const isWx = (/MicroMessenger/i).test(navigator.userAgent)
import router from './router'
// 适配
import './utils/flexible'
// 登录权限
import './permission'
import Vant from 'vant';
import 'vant/lib/index.css';
import { formatTime } from './utils/utils'
// 引入阿里矢量图文件
import './iconfont/iconfont.css'
Vue.use(Vant);

Vue.prototype.$tip = Tip
Vue.prototype.$types = types
Vue.prototype.wx = wx
Vue.prototype.$store = store

// Vue.use(VueRouter)
Vue.config.productionTip = false

// import pay from '@/pages/pay/index'
// 权限路由白名单

// 登录路由
// import BalancesList from '@/pages/wallet/BalancesList'
// import Balances from '@/pages/wallet/Balances'
// import Withdraw from '@/pages/wallet/Withdraw'

// const routes = [
//   { path: '/', component: Balances },
//   { path: '/pay', component: pay },
//   { path: '/wallet/balances-list', component: BalancesList },
//   { path: '/wallet/balances', component: Balances },
//   { path: '/wallet/withdraw', component: Withdraw },
// { path: '/login', component: login }
// ]
// // console.log(routes)
// const router = new VueRouter({
//   routes // (缩写) 相当于 routes: routes
// })


Vue.filter('toY', function (fee) {
	return ((fee || 0) / 100).toFixed(2);
})

Vue.filter('formatTime', function (value) {
	console.log(value)
	if (value) {
		value = new Date(value)
		return formatTime(value)
	}
})

// 解决浮点数的困扰
Vue.filter('fixedFloat', function (a, b, sign) {
	function handle(x) {
		var y = String(x)
		var p = y.lastIndexOf('.')
		if (p === -1) {
			return [y, 0]
		} else {
			return [y.replace('.', ''), y.length - p - 1]
		}
	}
	// v 操作数1, w 操作数2, s 操作符, t 精度
	function operate(v, w, s, t) {
		switch (s) {
			case '+':
				return (v + w) / t
			case '-':
				return (v - w) / t
			case '*':
				return (v * w) / (t * t)
			case '/':
				return (v / w)
	}
	}

	function padding0(p) {
		var z = ''
		while (p--) {
			z += '0'
		}
		return z
	}

	var c = handle(a)
	var d = handle(b)
	var k = 0

	if (c[1] === 0 && d[1] === 0) {
		return operate(+c[0], +d[0], sign, 1)
	} else {
		k = Math.pow(10, Math.max(c[1], d[1]))
		if (c[1] !== d[1]) {
			if (c[1] > d[1]) {
				d[0] += padding0(c[1] - d[1])
			} else {
				c[0] += padding0(d[1] - c[1])
			}
		}
		return operate(+c[0], +d[0], sign, k)
	}
})

Vue.filter('numToFixed', function (value) {
	return (value * 1).toFixed(2)
})

//转换我的积分类型
Vue.filter('toTransName', function (balanceType) {
	let tip
	switch (balanceType) {
		case 1:
			tip = "人工添加";
			break;
		case 2:
			tip = "积分获得";
			break;
		case 3:
			tip = "积分作废";
			break;
		case 4:
			tip = "积分兑换";
			break;
		case 5:
			tip = "积分退回";
			break;
		case 6:
			tip = "积分兑换费";
			break;
		case 8:
			tip = "积分结算";
			break;
		default:
			tip = "未定义类型";
			break;
	}
	return tip
})

Vue.filter('toTransDesc', function (item) {
	let desc
	switch (item.balanceType) {
		case 1:
			desc = `完成了每日任务获得了<span class="color-partner">${item.number / 100}</span>积分`;
			break;
		case 2:
			desc = `完成了每日任务获得了<span class="color-partner">${item.number / 100}</span>积分`;
			break;
		case 3:
			desc = "积分使用";
			break;
		case 4:
			desc = `兑换了<span>${number / 100}</span>元电子券`;
			break;
		case 5:
			desc = `退回<span>${number / 100}</span>元积分`;
			break;
		case 6:
			desc = "积分兑换费";
			break;
		case 8:
			desc = "积分结算";
			break;
		default:
			desc = "未定义类型";
			break;
	}
	return desc
})


new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')